<!--
 * @Description: 
 * @Author: xiaoyao
 * @since: 2020-06-05 10:19:39
 * @LastAuthor: @yangwenshan
 * @lastTime: 2021-10-26 11:28:18
--> 
<template>
  <!-- currentStep == 'apply-org-1' && !hasOrg -->
  <div class="my-org-wrapper" ref="org_wrapper">
    <a-popover :visible="false" placement="right">
      <div slot="content" style="text-align: right">
        <p>
          检测到你还未加入任何组织，请点击并选择“
          <a-icon type="plus"></a-icon>
          新的团队”
        </p>
        <a-button size="small" @click="handleJump">跳过</a-button>
      </div>

      <a-dropdown
        :getPopupContainer="() => $refs.org_wrapper"
        :trigger="['click']"
        style="max-width: 300px; padding: 0"
      >
        <span
          class="action"
          :class="
            currentStep == 'apply-org-1' && !hasOrg ? 'focus-operation' : ''
          "
          style="background: white; border-radius: 4px"
        >
          <a class="ant-dropdown-link">
            {{ orgName }}
            <a-icon type="down" />
          </a>
        </span>
        <a-menu v-if="loading" slot="overlay">
          <a-menu-item key="-2" style="text-align: center">
            <a-spin :spinning="loading" />
          </a-menu-item>
        </a-menu>
        <a-menu v-else slot="overlay">
          <a-menu-item v-for="item in my_orgs" :key="item.id">
            <a href="javascript:;" @click="onClickItem(item)">{{
              item.name
            }}</a>
          </a-menu-item>
          <a-menu-divider v-if="my_orgs.length" />
          <a-menu-item key="-1">
            <a href="javascript:;" @click="applyOrg">
              <a-icon type="plus"></a-icon>
              新的团队
            </a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </a-popover>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import router from "@/router";
import store from "@/store";
import { asyncRouterMap } from "@/config/router.config";
import { mixinDevice } from "@/utils/mixin";
export default {
  name: "MyOrgMenu",
  inject: ["reload"],
  mixins: [mixinDevice],
  data() {
    return {
      my_orgs: [],
      currentOrgId: null,
      selectedOrg: "",
      hasPath: false,
      loading: false,
    };
  },
  created() {
    this.my_orgs = this.orgList;
  },
  computed: {
    ...mapGetters(["org", "orgList", "currentStep"]),
    orgName() {
      const name = this.org.name || "";
      this.currentOrgId = this.org.id || null;
      if (name) {
        const xname = name.length > 4 ? name.substring(0, 4) + "..." : name;
        return this.isMobile() ? xname : name;
      } else {
        return "请选择团队";
      }
    },
    hasOrg() {
      return Boolean(Object.keys(this.org || {}).length > 0);
    },
  },
  methods: {
    ...mapActions(["setOrg", "setCurrentStep"]),
    handleJump() {
      this.setCurrentStep(null);
    },
    mapRouters(addRouters, path) {
      addRouters.forEach((route) => {
        if (route.path == path) {
          this.hasPath = true;
        } else if (route.children && route.children.length) {
          this.mapRouters(route.children, path);
        }
      });
    },
    refreshMenu() {
      const _this = this;
      return new Promise((resolve, reject) => {
        store
          .dispatch("GetInfo")
          .then((res) => {
            const perm_list = res && res.perm_list;
            const as = asyncRouterMap;
            store.dispatch("GenerateRoutes", { perm_list }).then(() => {
              // 根据perm_list权限生成可访问的路由表
              // 动态添加可访问路由表
              router.addRoutes(store.getters.addRouters);
              _this.mapRouters(store.getters.addRouters, _this.$route.path);
              if (!_this.hasPath) {
                reject();
              }
              resolve();
            });
          })
          .catch((err) => {
            this.$notification["error"]({
              message: "错误",
              description: "用户信息获取失败，请重试",
            });
            store.dispatch("Logout").then(() => {
              next({ path: "/user/login", query: { redirect: to.fullPath } });
            });
          });
      });
    },
    onClickItem(item) {
      if (item.id === this.currentOrgId) {
        return;
      }
      const _this = this;
      this.$confirm({
        title: "你想要切换企业/组织/团队吗?",
        content: (h) => (
          <div style="color:red;">
            确认后将立即更新页面数据，请确保你没有不想被打断的的工作哦
          </div>
        ),
        okText: "马上切换",
        cancelText: "我再考虑一下",
        onOk() {
          _this.selectedOrg = item.name;
          _this.currentOrgId = item.id;
          _this.setOrg(item);
          _this
            .refreshMenu()
            .then(() => {
              _this.reload();
            })
            .catch((err) => {
              _this.reload();
              _this.$router.push({ name: "Workplace" });
              _this.$notification["error"]({
                message: "错误",
                description: "当前页面不可访问，已为你跳转至工作台",
              });
            });
        },
        onCancel() {},
        class: "test",
      });
    },
    applyOrg() {
      this.$router.push({ name: "MyOrgs" });
      // this.setCurrentStep("apply-org-2");
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Tools/MyOrgMenu.vue